import Homepage from './components/Homepage'


const App = () => {
  return <Homepage />;

};
export default App;